import React from 'react';
import { Alert, Space, Tag, Typography, Collapse, Empty } from 'antd';

const { Text } = Typography;

const STATUS = {
    guarded: { type: 'warning', text: '健康数据陈旧，本轮会冻结，不会改动' },
    dryrun: { type: 'info', text: '服务端为演练模式（dryrun），应用也只记录不写入' },
    apply: { type: 'success', text: '应用后将按下列变更写入 DNS' },
    noop: { type: 'success', text: '已是最新，无需变更' },
};

// 渲染 GET /cdn/dns-sync/preview/{id} 的结果
const DnsSyncPlanView = ({ plan }) => {
    if (!plan) return null;
    const st = STATUS[plan.expected_status] || STATUS.noop;
    const add = plan.add || [];
    const remove = plan.remove || [];
    const notes = plan.notes || [];
    const verdicts = Object.entries(plan.verdicts || {});

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Alert type={st.type} showIcon message={st.text} description={<Text code>{plan.record}</Text>} />
            {!plan.group_active && <Alert type="warning" showIcon message="分组未启用，调度器不会同步该分组" />}
            {plan.guard_blocked_removals && (
                <Alert type="warning" showIcon message={`下限护栏生效：至少保留 ${plan.floor} 个节点`} />
            )}

            <div>
                <Text strong>新增 ({add.length})</Text>
                <div style={{ marginTop: 4 }}>
                    {add.length ? add.map((a) => <Tag key={a} color="green" style={{ marginBottom: 4 }}>+ {a}</Tag>) : <Text type="secondary">无</Text>}
                </div>
            </div>
            <div>
                <Text strong>删除 ({remove.length})</Text>
                <div style={{ marginTop: 4 }}>
                    {remove.length ? remove.map((r) => <div key={r}><Tag color="red">-</Tag><Text>{r}</Text></div>) : <Text type="secondary">无</Text>}
                </div>
            </div>
            {plan.retag > 0 && <Text type="secondary">另有 {plan.retag} 条仅更新备注/TTL</Text>}

            <Collapse
                size="small"
                items={[
                    {
                        key: 'v',
                        label: `节点裁决 (${verdicts.length}) · 当前记录 ${(plan.current || []).length} 条`,
                        children: verdicts.length ? (
                            <Space direction="vertical" size={2} style={{ width: '100%' }}>
                                {verdicts.map(([nid, v]) => (
                                    <div key={nid}>
                                        <Tag color={v === 'eligible' ? 'green' : 'orange'}>#{nid}</Tag>
                                        <Text type={v === 'eligible' ? undefined : 'warning'}>{v}</Text>
                                    </div>
                                ))}
                            </Space>
                        ) : <Empty description="该分组没有线路节点" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
                    },
                    ...(notes.length ? [{
                        key: 'n',
                        label: `备注 (${notes.length})`,
                        children: notes.map((n, i) => <div key={i}><Text type="secondary">{n}</Text></div>),
                    }] : []),
                ]}
            />
        </Space>
    );
};

export default DnsSyncPlanView;
